// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/semantic.min.css
// module id = 1171
// module chunks = 0